/* MobileFilterDialog.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Blanket from '@atlaskit/blanket';
import { useCloseOnEscapePress } from '@atlaskit/layering';
import { SlideIn } from '@atlaskit/motion';
import Portal from '@atlaskit/portal';
import React from 'react';
import FocusLock from 'react-focus-lock';
import { BottomPanel } from './BottomPanel';
import { MODAL_HEADING_ID } from './constants';
import { FiltersPanel } from './FiltersPanel';
import { TopPanel } from './TopPanel';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _15 = "._bfhkvuon{background-color:var(--ds-surface,#fff)}";
const _14 = "._qrwq1koz{border-top-right-radius:var(--ds-border-radius-300,.75rem)}";
const _13 = "._13li1koz{border-top-left-radius:var(--ds-border-radius-300,.75rem)}";
const _12 = "._2lx21bp4{flex-direction:column}";
const _11 = "._1e0c1txw{display:flex}";
const _10 = "._94n5idpf{bottom:0}";
const _9 = "._4t3i1h89{height:90dvh}";
const _8 = "._1bsbauwl{width:100vw}";
const _7 = "._kqsw1n9t{position:fixed}";
const _6 = "._ect4po1d{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,system-ui,\"Helvetica Neue\",sans-serif)}";
const _5 = "._19bvidpf{padding-left:0}";
const _4 = "._n3tdidpf{padding-bottom:0}";
const _3 = "._u5f3idpf{padding-right:0}";
const _2 = "._ca0qidpf{padding-top:0}";
const _ = "._19itglyw{border:none}";
// We're not using an @atlaskit/primitives component here as we need to pass the
// className prop to animate the dialog, which is not supported by primitives.
const DialogWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "dialog",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ect4po1d _kqsw1n9t _1bsbauwl _4t3i1h89 _94n5idpf _1e0c1txw _2lx21bp4 _13li1koz _qrwq1koz _bfhkvuon", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DialogWrapper.displayName = 'DialogWrapper';
}
export const MobileFilterDialog = _ref2 => {
  let {
    filterDefinitions,
    filterOptions,
    selectedOptions = {},
    sortOptions,
    selectedSortOption,
    filterStatus = {},
    onSelectedOptionsChange,
    onSelectedSortOptionChange,
    onClose,
    onClearAllFilters: _onClearAllFilters,
    onApplyFilters
  } = _ref2;
  useCloseOnEscapePress({
    onClose
  });
  return (
    /*#__PURE__*/
    // Setting z-index to 500 to match the recommended z-index for Blanket
    // https://atlassian.design/foundations/elevation#z-index
    _jsx(Portal, {
      zIndex: 500,
      children: /*#__PURE__*/_jsx(Blanket, {
        isTinted: true,
        onBlanketClicked: onClose,
        children: /*#__PURE__*/_jsx(SlideIn, {
          enterFrom: "bottom",
          fade: "in",
          children: _ref3 => {
            let {
              className,
              ref
            } = _ref3;
            return /*#__PURE__*/_jsx(FocusLock, {
              children: /*#__PURE__*/_jsxs(DialogWrapper, {
                className: className,
                ref: ref,
                open: true,
                "aria-modal": true,
                "aria-labelledby": MODAL_HEADING_ID,
                children: [/*#__PURE__*/_jsx(TopPanel, {
                  onClose: onClose,
                  enableSort: sortOptions.length > 0
                }), /*#__PURE__*/_jsx(FiltersPanel, {
                  filterDefinitions: filterDefinitions,
                  filterOptions: filterOptions,
                  selectedOptions: selectedOptions,
                  selectedSortOption: selectedSortOption,
                  sortOptions: sortOptions,
                  filterStatus: filterStatus,
                  onSelectedOptionsChange: onSelectedOptionsChange,
                  onSelectedSortOptionChange: onSelectedSortOptionChange
                }), /*#__PURE__*/_jsx(BottomPanel, {
                  onApplyFilters: onApplyFilters,
                  onClearAllFilters: () => _onClearAllFilters === null || _onClearAllFilters === void 0 ? void 0 : _onClearAllFilters({
                    location: 'mobile'
                  })
                })]
              })
            });
          }
        })
      })
    })
  );
};